<template lang="pug">
.event-list(v-if="list")
  .content(v-for="(item,i) in list" :key="i")
    .des.van-multi-ellipsis--l2 {{item.title}}
    .time.light {{item.date}}
</template>

<script>
import { dateToDateStr } from '@utils/time_helper'
export default {
  data() {
    return {
      list: null
    }
  },
  created() {
    this.$store.dispatch('getStockDetail').then(state => {
      if (!state) {
        return false
      }
      this.list = state.event_list.map(item => {
        return {
          date: dateToDateStr(item.date, '.'),
          title: item.title
        }
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
.event-list
  min-height 100vh
  box-sizing border-box
  background-color #fff
  padding 1rem
  .content
    border-bottom 1px solid $border-color
    padding 1.43rem 0
    .des
      // height 3rem
      font-size 1.07rem
      line-height 1.5rem
    .time
      margin-top .86rem
      font-size .86rem
</style>
